<template>
  <div class="kt-form kt-form--label-right">

    <div class="row">
      <div class="form-group col-md-4 validated px-5">
        <BaseSelect
          label="Supplier"
          :options="opportunityDetails.suppliers"
          v-model="$v[validationGroupName].quoteRequestTab.supplierId.$model"
          @blur="$v[validationGroupName].quoteRequestTab.supplierId.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.supplierId"
          :disabled="isSupplierDisabled || isCompletedQuote" />
      </div>
      <div class="form-group col-md-4 validated px-5">
        <BaseSelect
          label="Stage"
          :options="opportunityStages"
          v-model="$v[validationGroupName].quoteRequestTab.stageId.$model"
          @blur="$v[validationGroupName].quoteRequestTab.stageId.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.stageId"
          @input="updateOpportunityStage"
          :disabled="isSupplierDisabled || isGoAhead" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-4 col-12 px-5 colHotelStandard">
        <BaseRadioButtonGroup
          class="baseHotelStandard"
          label="Hotel standard"
          :options="hotelStandard"
          v-model="$v[validationGroupName].quoteRequestTab.hotelStandard.$model"
          @blur="$v[validationGroupName].quoteRequestTab.hotelStandard.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.hotelStandard"
          :disabled="isCompletedQuote">
          <font-awesome-icon class="ml-2 kt-label-font-color-1" :icon="['fas', 'star']" />
        </BaseRadioButtonGroup>
      </div>
      <div class="form-group col col-md-4 col-6 px-5">
        <BaseInputForm
          type="text"
          label="FOC Places"
          placeholder="1 Single"
          v-model="$v[validationGroupName].quoteRequestTab.focPlaces.$model"
          @blur="$v[validationGroupName].quoteRequestTab.focPlaces.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.focPlaces"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col col-md-4 col-6 px-5">
        <BaseInputForm
          type="text"
          label="Budget"
          placeholder="Ex. 2500"
          v-model="$v[validationGroupName].quoteRequestTab.budget.$model"
          @blur="$v[validationGroupName].quoteRequestTab.budget.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.budget"
          :disabled="isCompletedQuote" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-4 col-12 px-5">
        <BaseInputForm
          type="text"
          label="Price break"
          placeholder="Ex. 35 - 40"
          v-model="$v[validationGroupName].quoteRequestTab.priceBreak.$model"
          @blur="$v[validationGroupName].quoteRequestTab.priceBreak.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.priceBreak"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col col-md-4 col-6 px-5 validated">
        <BaseInputForm
          type="text"
          label="Guests"
          placeholder="Ex. 35"
          v-model="$v[validationGroupName].quoteRequestTab.guests.$model"
          @blur="$v[validationGroupName].quoteRequestTab.guests.$touch()"
          @keypress="isNumber"
          :validator="$v[validationGroupName].quoteRequestTab.guests"
          :disabled="isCompletedQuote" />
        <template v-if="$v[validationGroupName].quoteRequestTab.guests.$error">
          <div
            class="invalid-feedback"
            v-if="!$v[validationGroupName].quoteRequestTab.guests.numeric || !$v[validationGroupName].quoteRequestTab.guests.between">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Guests should be numeric greater than zero.</div>
        </template>
      </div>
      <div class="form-group col col-md-4 col-6 px-5 validated">
        <BaseInputForm
          type="text"
          label="Commission %"
          placeholder="Ex. 18"
          v-model="$v[validationGroupName].quoteRequestTab.commission.$model"
          @blur="$v[validationGroupName].quoteRequestTab.commission.$touch()"
          @keypress="isNumber"
          :validator="$v[validationGroupName].quoteRequestTab.commission"
          :disabled="isCompletedQuote" />
        <template v-if="$v[validationGroupName].quoteRequestTab.commission.$error">
          <div
            class="invalid-feedback"
            v-if="!$v[validationGroupName].quoteRequestTab.commission.numeric || !$v[validationGroupName].quoteRequestTab.commission.between">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Commission should be numeric.</div>
        </template>
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-4 col-6 px-5">
        <BaseInputForm
          type="text"
          label="Arr Airport/Port"
          placeholder="Ex. London LHR"
          v-model="$v[validationGroupName].quoteRequestTab.arrivalAirportPort.$model"
          @blur="$v[validationGroupName].quoteRequestTab.arrivalAirportPort.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.arrivalAirportPort"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col col-md-4 col-6 px-5">
        <BaseInputForm
          type="text"
          label="Dep Airport/Port"
          placeholder="Ex. Rome"
          v-model="$v[validationGroupName].quoteRequestTab.departureAirportPort.$model"
          @blur="$v[validationGroupName].quoteRequestTab.departureAirportPort.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.departureAirportPort"
          :disabled="isCompletedQuote" />
      </div>
      <div class="form-group col col-md-4 px-5">
        <BaseInputForm
          type="text"
          label="Quote deadline"
          placeholder="Ex. 15 weeks"
          v-model="$v[validationGroupName].quoteRequestTab.quoteDeadline.$model"
          @blur="$v[validationGroupName].quoteRequestTab.quoteDeadline.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.quoteDeadline"
          :disabled="isCompletedQuote" />
      </div>
    </div>

    <!-- Checklist -->
    <div class="row">
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.difficultDatesChecked.$model"
            @blur="$v[validationGroupName].quoteRequestTab.difficultDatesChecked.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.difficultDatesChecked"
            :disabled="isCompletedQuote"> Difficult dates checked <span></span>
        </label>
      </div>
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.flourishesLocalTreats.$model"
            @blur="$v[validationGroupName].quoteRequestTab.flourishesLocalTreats.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.flourishesLocalTreats"
            :disabled="isCompletedQuote"> Flourishes / Local treats <span></span>
        </label>
      </div>
      <div class="colCheckboxRequest form-group col col-12 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.birthdayAllowance.$model"
            @blur="$v[validationGroupName].quoteRequestTab.birthdayAllowance.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.birthdayAllowance"
            :disabled="isCompletedQuote"> Anniversary allowance <span></span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.prebookingsRequired.$model"
            @blur="$v[validationGroupName].quoteRequestTab.prebookingsRequired.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.prebookingsRequired"
            :disabled="isCompletedQuote"> Prebookings required <span></span>
        </label>
      </div>
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold verticalLine">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.gratuitiesForTdDriver.$model"
            @blur="$v[validationGroupName].quoteRequestTab.gratuitiesForTdDriver.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.gratuitiesForTdDriver"
            :disabled="isCompletedQuote"> Gratuities for TD &amp; Driver <span></span>
        </label>
      </div>
      <div class="colCheckboxRequest form-group col col-12 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.repeatGuestGift.$model"
            @blur="$v[validationGroupName].quoteRequestTab.repeatGuestGift.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.repeatGuestGift"
            :disabled="isCompletedQuote"> Global tour reward reception <span></span>
        </label>
      </div>
    </div>

    <div class="row rowCheckboxRequest">
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.tdOfferOptionals.$model"
            @blur="$v[validationGroupName].quoteRequestTab.tdOfferOptionals.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.tdOfferOptionals"
            :disabled="isCompletedQuote"> TD for offer optionals <span></span>
        </label>
      </div>
      <div class="colCheckboxRequest form-group col col-6 col-md-4 px-5">
        <label class="kt-checkbox kt-checkbox--bold ml-5 horizontalLine">
          <input
            type="checkbox"
            v-model="$v[validationGroupName].quoteRequestTab.includingLocalGuides.$model"
            @blur="$v[validationGroupName].quoteRequestTab.includingLocalGuides.$touch()"
            :validator="$v[validationGroupName].quoteRequestTab.includingLocalGuides"
            :disabled="isCompletedQuote"> Including local guides <span></span>
        </label>
      </div>
    </div>
    <!-- End Checklist -->

    <div class="row">
      <div class="form-group col">
        <label class="labelTitle">Additional information</label>
        <textarea
          class="form-control"
          rows="4"
          placeholder="Ex. Here you add extra information related to it."
          v-model="$v[validationGroupName].quoteRequestTab.additionalInformation.$model"
          @blur="$v[validationGroupName].quoteRequestTab.additionalInformation.$touch()"
          :validator="$v[validationGroupName].quoteRequestTab.additionalInformation"
          :disabled="isCompletedQuote"></textarea>
      </div>
    </div>

    <div class="row" v-if="validationGroupName === 'editOpportunity'">
      <div class="form-group col col-lg-12 col-xl-6">
        <label class="labelTitle">Attach file:</label>
        <FileUpload
          :isDisabled="isCompletedQuote"
          :config="fileUploadData">
          <template v-slot:info="{ config }">
            <small>
              <div>Maximum upload file size: {{ config.maxSize }}</div>
              <div>Accepted file types: {{ config.acceptedMimeTypesLabels }}</div>
            </small>
          </template>
        </FileUpload>
      </div>
    </div>

    <Portal to="goAheadModalPortal">
      <Modal :show="isModalShow">
        <div class="text-center mb-4">
          <font-awesome-icon
            class="text-info"
            :icon="['fas', 'eye']"
            size="4x"
          />
          <h1 class="text-info text-center my-4">Go Ahead?</h1>
          <button
            :disabled="isCompleting"
            class="btn btn-wide btn-light btn--cancel mr-1 font-weight-bold"
            @click="onCancel"
          >
            No, take me back
          </button>
          <button
            :disabled="isCompleting"
            class="btn btn-wide btn-info ml-1 font-weight-bold"
            @click="goAhead">
            <span v-if="!isCompleting">Yes, please go ahead</span>
            <span v-else>
                <font-awesome-icon
                  class="text-white"
                  :icon="['fas', 'spinner']"
                  spin
                />
              </span>
          </button>
        </div>
      </Modal>
    </Portal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import FileUpload from '@/components/_shared/file-upload/FileUpload.vue'
import {OPPORTUNITY__STAGES} from "@/constants";
import Modal from "@/components/_shared/Modal.vue";

export default {
  name: 'QuoteRequestFormTab',
  inject: ['$v'],
  components: {Modal, FileUpload },
  data () {
    return {
      isModalShow: false,
      isCompleting: false,
      hotelStandard: [
        { value: 3, text: '3' },
        { value: 3.5, text: '3.5' },
        { value: 4, text: '4' },
        { value: 5, text: '5' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      'opportunityDetails': 'opportunity/opportunityDetails',
      'permissions': 'opportunity/permissions'
    }),
    opportunityStages() {
      return this.opportunityDetails.stages.filter((stage) => {
        if (this.isCompletedQuote)
          return [OPPORTUNITY__STAGES.SALES_QUOTE_SENT, OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD].includes(stage.value);
        return stage.value !== OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD;
      });
    },
    isSupplierDisabled () {
      if (
        this.permissions &&
        this.permissions.supplier &&
        this.permissions.supplier === 'disabled') {
        return true
      }
      return false
    },
    fileUploadData () {
      const uuid = this.$route.params.privateId
      return {
        uuid,
        path: `images/files/opportunity/${uuid}/request-form`,
        userId: this.opportunityDetails ? this.opportunityDetails.owner : null,
        minSize: '1KB',
        maxSize: '20MB',
        multiple: true,
        acceptedMimeTypes: [
          { ext: '.png', mimeType: 'image/png' },
          { ext: '.jpg, .jpeg', mimeType: 'image/jpeg' },
          { ext: '.pdf', mimeType: 'application/pdf' },
          { ext: '.doc', mimeType: 'application/msword' },
          { ext: '.docx', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
          { ext: '.xls', mimeType: 'application/vnd.ms-excel' },
          { ext: '.xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        ]
      }
    },
    isGoAhead () {
      return (
        parseInt(this.$v[this.validationGroupName].quoteRequestTab.stageId.$model) === OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD
      );
    },
  },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    save: {
      type: Function,
      default: () => {},
    }
  },
  methods: {
    onCancel () {
      this.$v[this.validationGroupName].quoteRequestTab.stageId.$model = OPPORTUNITY__STAGES.SALES_QUOTE_SENT;
      this.isModalShow = false;
    },
    updateOpportunityStage (stage_id) {
      if (OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD === parseInt(stage_id)) {
        this.isModalShow = true;
      }
    },
    goAhead () {
      this.isCompleting = true;
      this.save(true, false, () => {
        this.isModalShow = false;
      });
    },
    isNumber (e) {
      // https://stackoverflow.com/a/39786700
      const evt = e || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        e.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>
